var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageBreadcrumbs',{attrs:{"items":[
    ['Minhas Tarefas','/tasks'],
    ['Concluídas','/tasks/completed'] ]}},[_c('v-btn',{staticClass:"mr-3 font-weight-medium",staticStyle:{"font-size":"11px"},attrs:{"to":"/tasks","depressed":"","color":"success"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-arrow-left")]),_vm._v(" Voltar para Tarefas ativas ")],1)],1),_c('TasksList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }